import React from "react";

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlightKeywordMatches(
  text: string,
  matches: string[]
): React.ReactNode[] {
  if (!matches.length) return [text];

  const pattern = matches.map(escapeRegex).join("|");
  const regex = new RegExp(`\\b(${pattern})\\b`, "gi");

  const parts = text.split(regex);

  return parts.map((part, i) => {
    if (i % 2 === 1) {
      return React.createElement(
        "span",
        {
          key: i,
          className:
            "bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200 rounded px-0.5",
        },
        part
      );
    }
    return part;
  });
}

export function highlightSubstringMatches(
  text: string,
  searchTerm: string
): React.ReactNode[] {
  if (!searchTerm.trim()) return [text];
  const rawTokens = searchTerm.trim().split(/\s+/);
  const tokens = rawTokens.filter(t => t.length >= 2);
  const phraseMode = tokens.length <= 1 && tokens.length < rawTokens.length;
  const pattern = phraseMode
    ? escapeRegex(searchTerm.trim())
    : tokens.length > 0
      ? tokens.map(escapeRegex).join("|")
      : escapeRegex(searchTerm.trim());
  const regex = new RegExp(`(${pattern})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, i) => {
    if (i % 2 === 1) {
      return React.createElement(
        "span",
        {
          key: i,
          className:
            "bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-200 rounded px-0.5",
        },
        part
      );
    }
    return part;
  });
}
